class UserSaveController {

    constructor(authService) {
        this.authService = authService;
    }

    $onInit() {
        this.activeTab = 'profile';
    }
}

UserSaveController.$inject = [ 'authService' ];

export default UserSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/controllers/user.save.controller.js